export const TOKEN_KEY = 'token';

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const login = (token, id_empresa) => {
    localStorage.setItem('empresa_id', id_empresa);
    localStorage.setItem(TOKEN_KEY, token);
};
export const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    window.location.href = '/';
};

